<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          <strong>Υπόθεση Πελάτη: </strong>{{ client }}<br />
          <div v-if="case_code != 'pending' && status.value != 4">
            <strong>Αριθμός Υπόθεσης: </strong>{{ case_code }}
          </div>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CModal
              class="modalAlert"
              :show.sync="alertIsShown"
              :centered="true"
              size="lg"
            >
              <CAlert
                closeButton
                :show.sync="alertIsShown"
                color="primary"
                fade
              >
                {{ message }}
              </CAlert>
            </CModal>
            <CInput
              v-if="case_code == 'pending' && status.value != 4"
              label="Αριθμός υπόθεσης"
              type="number"
              v-model="case_number"
              class="fullInputHeight"
              horizontal
              :prepend="case_code_prefix"
              addLabelClasses="requiredLabel"
              :lazy="false"
              :disabled="true"
              @change="val => (case_number = pad(case_number, 5))"
            >
              <template #append>
                <multiselect
                  placeholder="Τύπος επιθεώρησης"
                  v-model="inspection_type"
                  trackBy="value"
                  label="label"
                  :options="inspection_types"
                >
                </multiselect>
              </template>
            </CInput>
            <div class="form-row form-group" v-if="case_code != 'pending'">
              <CCol sm="3" class="requiredLabel">
                Τύπος επιθεώρησης
              </CCol>
              <CCol sm="9">
                <multiselect
                  placeholder="Τύπος επιθεώρησης"
                  v-model="inspection_type"
                  trackBy="value"
                  label="label"
                  :options="inspection_types"
                >
                </multiselect>
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Ημέρες επίσκεψης
              </CCol>
              <CCol sm="9">
                <multiselect
                  v-model="days"
                  id="days"
                  @input="addDays"
                  :options="daysOptions"
                  placeholder="Ημέρες"
                >
                </multiselect>
              </CCol>
            </div>
            <CInput
              v-for="(item, index) in next_visit"
              :key="index"
              :label="'Επόμενη επίσκεψη (' + (index + 1) + ')'"
              type="date"
              v-model="next_visit[index]"
              horizontal
              addLabelClasses="requiredLabel"
            />
            <CInput
              horizontal
              type="text"
              label="Τοποθεσία"
              id="location"
              placeholder="Τοποθεσία"
              v-model="location"
            ></CInput>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Κατάσταση
              </CCol>
              <CCol sm="9">
                <multiselect
                  v-model="status"
                  id="status"
                  :options="statusOptions"
                  label="label"
                  @input="updateStatus"
                  track-by="label"
                >
                </multiselect>
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Πρότυπο
              </CCol>
              <CCol sm="9">
                <multiselect
                  v-model="service"
                  id="service"
                  :options="servicesOptions"
                  :disabled="true"
                  label="label"
                  @input="refreshSubcategory(0)"
                  track-by="label"
                >
                </multiselect>
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                ΕΑ/NACE
              </CCol>
              <CCol sm="9">
                <multiselect
                  v-model="service_subcategory"
                  id="service_subcategory"
                  :options="serviceSubcategoryOptions"
                  label="label"
                  multiple
                  :disabled="subDisabled"
                  track-by="label"
                >
                </multiselect>
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol sm="3" class="requiredLabel">
                Τιμολόγιο
              </CCol>
              <CCol sm="9">
                <multiselect
                  v-model="bill_status"
                  id="bill_status"
                  :options="billStatusesOptions"
                  label="label"
                  track-by="label"
                  @input="checkStatus"
                >
                </multiselect>
                <CBadge
                  color="danger"
                  class="inspectorBadge"
                  v-show="!wasIssued"
                >
                  Δεν έχει εκδοθεί τιμολόγιο.
                </CBadge>
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol sm="12">
                Επιθεωρητές
              </CCol>
              <CCol sm="12">
                <CButton color="primary" @click="refreshInspectors()"
                  >Ανανέωση Επιθεωρητών</CButton
                >
              </CCol>
              <CCol sm="12" class="pt-2">
                <template v-for="(item, index) in inspectors">
                  <CRow :key="`row-${item.id}`" class="pb-2">
                    <CCol sm="3" :key="`inspector-${item.id}`">
                      <label class="requiredLabel">Επιθεωρητής</label>
                      <multiselect
                        v-model="item.inspector"
                        :options="inspectorOptions"
                        label="label"
                        @input="calculateDates(index)"
                        :show-labels="false"
                        track-by="value"
                      >
                      </multiselect>
                      <CBadge
                        color="danger"
                        class="inspectorBadge"
                        v-show="item.inspector && item.taken"
                      >
                        Ο/Η επιθεωρητής έχει ανατεθεί σε άλλη υπόθεση κατά την
                        επιλεγμένη ημερομηνία.
                      </CBadge>
                    </CCol>
                    <CCol sm="3" :key="`role-${item.id}`">
                      <label class="requiredLabel">Ρόλος</label>
                      <multiselect
                        v-model="item.role"
                        :options="roles"
                        label="label"
                        :show-labels="false"
                        track-by="value"
                      >
                      </multiselect>
                    </CCol>
                    <CCol sm="2" :key="`price-${item.id}`">
                      <label class="requiredLabel">Τιμή</label>
                      <multiselect
                        v-model="item.price"
                        :options="priceOptions"
                        label="label"
                        :show-labels="false"
                        :taggable="true"
                        @tag="newTag => addTag(newTag, index)"
                        track-by="value"
                      >
                      </multiselect>
                    </CCol>
                    <CCol sm="2" :key="`date-${item.id}`">
                      <label class="requiredLabel">Ημερομηνία</label>
                      <multiselect
                        @input="calculateDates(index)"
                        v-model="item.date"
                        :show-labels="false"
                        :options="next_visit"
                      >
                      </multiselect>
                    </CCol>
                    <CCol sm="2">
                      <label>Πληρώθηκε</label><br />
                      <CSwitch
                        :checked.sync="item.paid"
                        shape="pill"
                        color="success"
                        class="v-middle"
                      />
                    </CCol>
                  </CRow>
                </template>
              </CCol>
              <CCol sm="12">
                <CButton v-show="showAdd" color="primary" @click="addRow()"
                  >Προσθήκη</CButton
                >
              </CCol>
            </div>
            <CInput
              label="Επανάληψη σε"
              append="μήνες"
              horizontal
              v-show="showMonths && !created_next_case"
              v-model="revision_months"
            />
            <!--CInput
              label="Αριθμός επόμενης υπόθεσης"
              type="number"
              v-model="next_case_number"
              horizontal
              :prepend="case_code_prefix"
              v-show="showMonths && revision_months > 0 && ! created_next_case"
              addLabelClasses="requiredLabel"
              :lazy="false"
              @change="(val) => next_case_number = pad(next_case_number, 5)"
            /-->
          </CForm>
        </CCardBody>
      </CCard>

      <CCard>
        <CCardHeader>
          <strong>Σύμβουλος - Υπεργολάβος</strong>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <div class="form-row form-group">
              <CCol>
                <label>Σύμβουλος/Πωλητής</label>
                <multiselect
                  v-model="consultant"
                  :options="consultantOptions"
                  label="name"
                  :show-labels="false"
                  track-by="id"
                >
                </multiselect>
              </CCol>
              <CCol>
                <CInput label="Ποσό" type="number" v-model="consultant_price" />
              </CCol>
            </div>
            <div class="form-row form-group">
              <CCol>
                <label>Υπεργολάβος</label>
                <multiselect
                  v-model="subcontractor"
                  :options="subcontractorOptions"
                  label="name"
                  :show-labels="false"
                  track-by="id"
                >
                </multiselect>
              </CCol>
              <CCol>
                <CInput
                  label="Ποσό"
                  type="number"
                  v-model="subcontractor_price"
                />
              </CCol>
            </div>
            <CButton color="primary" @click="update()">Αποθήκευση</CButton>
            <CButton color="primary" @click="goBack">Πίσω</CButton>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import MaskedInput from "vue-text-mask";
import { DatePicker } from "v-calendar";
import "vue-multiselect/dist/vue-multiselect.min.css";
import Multiselect from "vue-multiselect";
export default {
  name: "EditCase",
  components: {
    "v-date-picker": DatePicker,
    MaskedInput,
    Multiselect
  },
  props: {
    caption: {
      type: String,
      default: "Case id"
    }
  },
  data: () => {
    return {
      statusOptions: [],
      next_visit: [""],
      days: 1,
      daysOptions: [...Array(30).keys()].map(i => i + 1),
      location: "",
      status: "",
      client: "",
      showMessage: false,
      servicesOptions: [],
      service_subcategory: "",
      service: "",
      showMonths: false,
      case_code: "",
      message: "",
      alertIsShown: false,
      billStatusesOptions: [],
      alertIsShown: false,
      bill_status: "",
      roles: [],
      inspectorOptions: [],
      case_code_prefix: "0000.",
      case_number: "",
      //next_case_number: '',
      created_next_case: false,
      inspection_types: [],
      inspection_type: "",
      priceOptions: [
        {
          label: 0,
          value: 0
        },
        {
          label: 25,
          value: 25
        },
        {
          label: 150,
          value: 150
        },
        {
          label: 200,
          value: 200
        }
      ],
      inspectors: [],
      consultantOptions: [],
      subcontractorOptions: [],
      subDisabled: true,
      active: true,
      showAdd: true,
      subcontractor: null,
      consultant: null,
      subcontractor_price: null,
      consultant_price: null,
      dismissSecs: 7,
      revision_months: 0,
      serviceSubcategoryOptions: [],
      dismissCountDown: 0,
      showDismissibleAlert: false,
      masks: {
        input: "YYYY-MM-DD",
        data: ["YYYY-MM-DD"]
      },
      originalStatus: null,
      isPublished: false,
      wasIssued: true,
    };
  },
  computed: {
    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (!newVal && this.saved) {
        this.$emit("closed-alert");
      }
    }
  },
  methods: {
    checkStatus(){
      let self = this;
      if(self.bill_status.value === 2){
        axios
          .get( "/api/case/"+self.$route.params.id+"/check/issued?token="+localStorage.getItem("api_token"))
          .then(function(response) {
            self.wasIssued = response.data.issued
          })
          .catch(function(error) {
              console.log(error);
              self.$router.push({ path: "/login" });
          });
      }else{
        self.wasIssued = true
      }
    },
    calculateDates(index) {
      let item = this.inspectors[index];
      let taken = false;
      if (item.inspector && item.date) {
        taken = item.inspector.dates.includes(item.date);
      }
      this.inspectors[index].taken = taken;
    },
    goBack() {
      this.$router.go(-1);
      // this.$router.replace({path: '/clients'})
    },
    updateStatus() {
      //ολοκληρωμένη
      if (this.status && this.status.value == 5) {
        this.showMonths = true;
      } else {
        this.showMonths = false;
      }

      //ακυρώθηκε
      if (this.status && this.status.value == 4) {
        this.inspectors = [];
      }
    },
    update() {
      let self = this;
      let subcategories = self.service_subcategory.map(item => {
        return item.value;
      });
      let inspectors = self.inspectors.filter(
        item => item.inspector || item.role || item.price || item.date
      );
      inspectors = inspectors.map(item => {
        let newItem = {};
        if (item.inspector) newItem.id = item.inspector.value;
        if (item.role) newItem.role = item.role.value;
        if (item.price) newItem.price = item.price.value;
        if (item.date) newItem.date = item.date;
        newItem.paid = item.paid;

        return newItem;
      });
      let status = null;
      if (this.status) {
        status = this.status.value;
      }

      let bill_status = null;
      if (this.bill_status) {
        bill_status = this.bill_status.value;
      }
      let data = {
        _method: "PUT",
        next_visit: self.next_visit,
        location: self.location,
        status: status,
        service_id: self.service.value,
        service_subcategories: subcategories,
        inspectors: inspectors,
        revision_months: self.revision_months,
        bill_status: bill_status,
        subcontractor_id: self.subcontractor ? self.subcontractor.id : null,
        consultant_id: self.consultant ? self.consultant.id : null,
        subcontractor_price: self.subcontractor_price,
        consultant_price: self.consultant_price,
        inspection_type: self.inspection_type
          ? self.inspection_type.value
          : null
      };

      if (self.case_code == "pending") {
        //if it isn't unscheduled or cancelled, it will take a case number
        if (
          self.status.value != 1 &&
          self.status.value != 4 &&
          self.isPublished === false
        ) {
          data.case_code = self.case_code_prefix + self.case_number;
          data.frompending = true;
        }
      }

      axios
        .post(
          "/api/cases/" +
            self.$route.params.id +
            "?token=" +
            localStorage.getItem("api_token"),
          data
        )
        .then(function(response) {
          self.message = "Επιτυχής επεξεργασία υπόθεσης.";
          self.showAlert();
          if (self.status.value != 1 && self.status.value != 4) {
            self.isPublished = true;
          }
          // self.$router.push({ path: "/cases" });
        })
        .catch(function(error) {
          if (error.response.data.message == "The given data was invalid.") {
            self.message = "";
            for (let key in error.response.data.errors) {
              if (error.response.data.errors.hasOwnProperty(key)) {
                self.message += error.response.data.errors[key][0] + "  ";
              }
            }
            self.showAlert();
          } else {
            console.log(error);
            self.$router.push({ path: "/login" });
          }
        });
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    addRow() {
      let self = this;
      var id =
        Math.max.apply(
          Math,
          self.inspectors.map(function(o) {
            return o.id;
          })
        ) + 1;
      self.showAdd = true;
      self.inspectors.push({
        id,
        inspector: "",
        role: "",
        price: "",
        paid: false,
        date: "",
        taken: false
      });
      if (self.inspectors.length >= 25) {
        self.showAdd = false;
      }
    },
    addTag(newTag, index) {
      const tag = {
        label: newTag,
        value: newTag
      };
      this.priceOptions.push(tag);
      this.inspectors[index].price = tag;
    },
    addDays() {
      console.log(this.days);
      if (this.days < this.next_visit.length) {
        this.next_visit.splice(0, this.days);
      } else {
        for (let i = this.next_visit.length; i < this.days; i++) {
          this.next_visit.push("");
        }
      }
    },
    showAlert() {
      this.alertIsShown = true;
    },
    pad(num, size) {
      num = num.toString();
      while (num.length < size) num = "0" + num;
      return num;
    },
    refreshSubcategory(subcategories) {
      let self = this;
      if (self.service && self.service.code) {
        self.subDisabled = true;
        self.case_code_prefix = self.service.code + ".";
        self.case_number = self.pad(self.service.case_count + 1, 5);
        //self.next_case_number = self.pad(self.service.case_count + 1, 5);

        axios
          .get(
            "/api/services/get_subcategories/" +
              self.service.value +
              "?token=" +
              localStorage.getItem("api_token")
          )
          .then(function(response) {
            self.serviceSubcategoryOptions = response.data.service_subcategories.map(
              item => {
                return {
                  value: item.id,
                  label: item.name
                };
              }
            );
            if (subcategories) {
              let ids = subcategories.map(item => {
                return item.id;
              });
              self.service_subcategory = self.serviceSubcategoryOptions.filter(
                item => ids.includes(item.value)
              );
            } else {
              self.service_subcategory = [];
            }
            self.subDisabled = false;
          })
          .catch(function(error) {
            console.log(error);
            self.$router.push({ path: "/login" });
          });
      }
    },
    refreshInspectors() {
      let self = this;
      if (self.service && self.service_subcategory) {
        let subcategories = self.service_subcategory.map(item => {
          return item.value;
        });
        axios
          .get(
            "/api/inspectors/get_filtered_inspectors?token=" +
              localStorage.getItem("api_token"),
            {
              params: {
                service_id: self.service.value,
                subcategories: subcategories,
                case_id: self.$route.params.id
              }
            }
          )
          .then(function(response) {
            self.inspectorOptions = response.data.inspectors.map(item => {
              return {
                value: item.id,
                label: item.name,
                dates: item.cases.map(item => item.pivot.date)
              };
            });
          })
          .catch(function(error) {
            if (error.response.data.message == "The given data was invalid.") {
              self.message = "";
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + "  ";
                }
              }
              self.showAlert();
            } else {
              self.$router.push({ path: "/login" });
            }
          });
      }
    }
  },
  mounted: function() {
    let self = this;
    self.isPublished = false;
    axios
      .get(
        "/api/cases/" +
          self.$route.params.id +
          "/edit?token=" +
          localStorage.getItem("api_token")
      )
      .then(function(response) {
        self.case_code = response.data.case.case_code;
        self.next_visit = response.data.case.next_visit;
        self.days = self.next_visit.length;
        self.inspection_types = response.data.inspection_types.map(
          (item, index) => {
            return {
              label: item,
              value: index
            };
          }
        );
        self.inspection_type =
          self.inspection_types[response.data.case.inspection_type];

        self.location = response.data.case.location;
        self.status = response.data.case.status;
        self.created_next_case = response.data.case.created_next_case;
        if (self.status.name == "Ολοκληρωμένη") {
          self.showMonths = true;
        }
        self.statusOptions = response.data.statuses.map(item => {
          return {
            label: item.name,
            value: item.id
          };
        });
        self.servicesOptions = response.data.services.map(item => {
          return {
            value: item.id,
            label: item.name,
            code: item.case_code_prefix,
            case_count: item.case_count
          };
        });

        self.originalStatus = self.status.id;
        self.status = { label: self.status.name, value: self.status.id };
        self.client = response.data.case.client.company;
        self.service = {
          value: response.data.case.service.id,
          label: response.data.case.service.name,
          code: response.data.case.service.case_code_prefix,
          case_count: response.data.case.service.case_count
        };

        self.case_code_prefix = self.service.code + ".";
        self.case_number = self.pad(self.service.case_count + 1, 5);
        //self.next_case_number = self.pad(self.service.case_count + 1, 5);

        self.revision_months = response.data.case.revision_months;
        self.serviceSubcategoryOptions = response.data.service_subcategories.map(
          item => {
            return {
              value: item.id,
              label: item.name
            };
          }
        );

        self.service_subcategory = response.data.case.service_subcategories.map(
          item => {
            return {
              label: item.name,
              value: item.id
            };
          }
        );
        self.subDisabled = false;
        self.billStatusesOptions = response.data.bill_statuses.map(item => {
          return {
            label: item.name,
            value: item.id
          };
        });
        self.roles = response.data.inspectors_roles.map(item => {
          return {
            label: item.role,
            value: item.id
          };
        });
        self.subcontractorOptions = response.data.subcontractors;
        self.consultantOptions = response.data.consultants;

        if (response.data.case.consultant_id) {
          self.consultant = self.consultantOptions.find(
            item => item.id == response.data.case.consultant_id
          );
        }

        if (response.data.case.subcontractor_id) {
          self.subcontractor = self.subcontractorOptions.find(
            item => item.id == response.data.case.subcontractor_id
          );
        }

        self.subcontractor_price = response.data.case.subcontractor_price;
        self.consultant_price = response.data.case.consultant_price;

        if (response.data.case.bill_status) {
          self.bill_status = {
            label: response.data.case.bill_status.name,
            value: response.data.case.bill_status.id
          };
        }
        self.inspectorOptions = response.data.inspectors.map(item => {
          return {
            label: item.name,
            value: item.id,
            dates: item.cases.map(item => item.pivot.date)
          };
        });
        let inspectors = response.data.case.inspectors;
        self.inspectors = inspectors.map((item, index) => {
          let price = self.priceOptions.find(
            price => price.value == item.pivot.price
          );
          if (!price) {
            price = { value: item.pivot.price, label: item.pivot.price };
            self.priceOptions.push(price);
          }
          let inspector = self.inspectorOptions.find(i => i.value == item.id);
          return {
            id: index,
            inspector: inspector,
            role: self.roles.find(role => role.value == item.pivot.role_id),
            price: price,
            paid: item.pivot.paid == 1 ? true : false,
            date: item.pivot.date,
            taken: inspector.dates.includes(item.pivot.date)
          };
        });

        if (self.inspectors.length >= 25) {
          self.showAdd = false;
        }
      })
      .catch(function(error) {
        console.log(error);
        self.$router.push({ path: "/login" });
      });
  }
};
</script>
